<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Schedule Guide</h3>
      </div>
    </div>
  </div>
</div>

<dl class="row ">
      <dt class="col-12 text-danger"><h5>How to fill schedule input box? Ans: <span class="text-warning">Filled by ','</span> </h5> </dt>
      <dd class="col-12"></dd>
      <dt class="col-12">When IntevalMode is Day</dt>
      <dd class="col-12">
        <table id="dayList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
          <thead class="thead-dark">
            <tr>
              <th>\</th>
              <th>0am</th>
              <th>...</th>
              <th>9am</th>
              <th>...</th>
              <th>12pm</th>
              <th>...</th>
              <th>6pm</th>
              <th>...</th>
              <th>11pm</th>
              <th>Scope</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Schedule Value</td>
              <td>0</td>
              <td>1-8</td>
              <td>9</td>
              <td>10 - 11</td>
              <td>12</td>
              <td>13 - 17</td>
              <td>18</td>
              <td>19 - 22</td>
              <td>23</td>
              <td>0 - 23</td>
            </tr>
          </tbody>
          <caption>
            <span class="font-weight-bold font-italic text-danger">*Example*: </span> Renewal at <span class="font-italic text-warning">11am.</span> and <span  class="font-italic text-warning">4pm</span>  every day, the schedules value is <span class="font-italic text-warning">11,16</span>
          </caption>
        </table>
      </dd>

      <dt class="col-12">When IntevalMode is Week</dt>
      <dd class="col-12">
        <table id="dayList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
          <thead class="thead-dark">
            <tr>
              <th>\</th>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
              <th>Scope</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Schedule Value</td>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>6</td>
              <td>7</td>
              <td>1 - 7</td>
            </tr>
          </tbody>
          <caption>
            <span class="font-weight-bold font-italic text-danger">*Example*: </span>  Renewal at <span class="font-italic text-warning"> Mon.</span>, <span class="font-italic text-warning">Wed.</span> and <span class="font-italic text-warning">Fri.</span> every week, the schedules value is <span class="font-italic text-warning">1,3,5</span>
          </caption>
        </table>
      </dd>


      <dt class="col-12">When IntevalMode is Month</dt>
      <dd class="col-12">
        <table id="dayList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
          <thead class="thead-dark">
            <tr>
              <th>\</th>
              <th>Day 1</th>
              <th>...</th>
              <th>Day 10</th>
              <th>Day N</th>
              <th>Scope</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Schedule Value</td>
              <td>1</td>
              <td>2 - 9</td>
              <td>10</td>
              <td>N</td>
              <td>1 - 31</td>
            </tr>
          </tbody>
        </table>
      </dd>
</dl>

<!-- <div class="table-responsive"> -->

